import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap, catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';

import { HomeProfileService } from './info.service';
import {
  loadProfileInfo,
  loadProfileInfoSuccess,
  loadProfileInfoById,
  loadProfileReferences,
  loadProfileReferencesSuccess,
  addReference,
  addReferenceSuccess
} from './info.actions';
import { addInfoMessage } from 'src/app/pages/components/info-message/info-message.actions';
import { Error403Component } from 'src/app/pages/error-403/error-403.component';
import { RoutingService } from 'src/app/core/services/routing.service';

@Injectable()
export class ProfileInfoEffects {
  constructor(
    private actions$: Actions,
    private service: HomeProfileService,
    private routing: RoutingService
  ) {}

  effectForLoadProfileInfo$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadProfileInfo),
      switchMap(() =>
        this.service.getUserInfo().pipe(
          switchMap((data) => [
            // addInfoMessage({
            //   infoMessage: {
            //     type: 'alert-success',
            //     message: data?.message
            //   }
            // }),
            loadProfileInfoSuccess({ profileInfo: data })
          ])
        )
      )
    )
  );

  loadProfileInfoById$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadProfileInfoById),
      switchMap((args) =>
        this.service.getUserInfoById(args.profileId).pipe(
          map((data) => loadProfileInfoSuccess({ profileInfo: data })),
          catchError((_) =>
            this.handleProfileInfoError(_.error, { id: args.profileId })
          )
        )
      )
    )
  );

  effectForLoadProfileReferences$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadProfileReferences),
      switchMap((args) =>
        this.service.getUserReferences(args.profileId).pipe(
          switchMap((data) => [
            // addInfoMessage({
            //   infoMessage: {
            //     type: 'alert-success',
            //     message: data?.message
            //   }
            // }),
            loadProfileReferencesSuccess({ references: data })
          ])
        )
      )
    )
  );

  effectForAddReference$ = createEffect(() =>
    this.actions$.pipe(
      ofType(addReference),
      switchMap((args) =>
        this.service.addReference(args.reference).pipe(
          switchMap((data) => [
            addInfoMessage({
              infoMessage: {
                type: 'alert-success',
                message: data?.message || 'Reference Added'
              }
            }),
            addReferenceSuccess({ reference: data })
          ])
        )
      )
    )
  );

  private handleProfileInfoError(error, params) {
    console.log('handleProfileInfoError: ', error);

    switch (error.code) {
      case 403:
        this.routing.goTo403({
          skipLocationChange: true,
          state: { type: Error403Component.Type.User, ...params }
        });
        break;
      default:
        // TODO: redo to goTo400
        this.routing.goTo403({
          skipLocationChange: true,
          state: { type: Error403Component.Type.User, ...params }
        });
    }

    return of(loadProfileInfoSuccess({ profileInfo: null }));
  }
}
